import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserGuideService } from 'src/app/Components/user-guide/user-guide.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GuideServiceService } from 'src/app/User/Components/user-guide/guide-service.service';
import { UserService } from 'src/app/User/Service/user.service';
@Component({
    selector: 'app-user-guide',
    templateUrl: './user-guide.component.html',
    styleUrls: ['./user-guide.component.css'],
    standalone: false
})
export class UserGuideComponent implements OnInit {
  constructor(
    private dialog: NgbModal,
    public userService: UserService,
    private userGuideService: UserGuideService,
    private route: Router,
    private domSanitizer: DomSanitizer,
    public guideService: GuideServiceService
  ) {}
  url = '';
  @Input() info: any = {};
  @Input() showGetstart = true;
  @Input() showDontshowClick = true;
  dontShowAgain = false;
  ngOnInit(): void {
    if (this.info.content.videoLink) {
      const url = this.domSanitizer.sanitize(
        SecurityContext.URL,
        this.info.content.videoLink.toString()
      );
      this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(
        url
      ) as string;
    }
  }
  showVideo = false;

  closeModel() {
    if (this.dontShowAgain) this.userGuideService.dontShow(this.info.name);
    this.dialog.dismissAll();
    if (this.info.name == 'calendar') this.guideService.refresh(true);
  }
}
